import { StrictMode } from "react";
import { createRoot, type Root } from "react-dom/client";
import TournamentHostBanner from "./TournamentHostBanner";
import { findTournamentHostBanner } from "./tournamentHostBanners";

const MOUNT_ID = "thb-root";

let root: Root | null = null;

export function mountTournamentHostBanner(
  element?: Element | null,
  path: string = window.location.pathname,
) {
  const target =
    element ??
    document.getElementById(MOUNT_ID) ??
    document.querySelector("[data-thb-root]");

  if (!target) {
    console.warn(
      `[TournamentHostBanner] No mount node found. Add <div id="${MOUNT_ID}"></div> to the Custom HTML block.`,
    );
    return;
  }

  const banner = findTournamentHostBanner(path);

  if (!banner) {
    console.warn(
      `[TournamentHostBanner] No host banner configured for path "${path}".`,
    );
    return;
  }

  if (root) {
    root.unmount();
  }

  root = createRoot(target);

  root.render(
    <StrictMode>
      <TournamentHostBanner {...banner} />
    </StrictMode>,
  );
}

function boot() {
  mountTournamentHostBanner();
}

if (!import.meta.env.VITEST) {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
}
